<div class="hc" *ngIf="empresa">

  <div class="hc-ola" *ngIf="saudacao as ola"><small>{{ola.detalhe}}</small><h1>{{ola.titulo}}</h1></div>

  <!-- Loja recebendo pedido com o caixa fechado: aviso no topo, não linha neutra em "Agora na loja". -->
  <button type="button" class="hc-som" *ngIf="momento === 'aberta' && exibirCaixa && !caixa.aberto && !visaoCaixa" (click)="abraRota('/admin/meupdv')">
    <i class="fe-inbox" aria-hidden="true"></i>
    <span class="hc-linha__txt"><b>Caixa fechado</b><span>Abra o caixa para registrar os pagamentos de hoje.</span></span>
  </button>

  <ng-container [ngSwitch]="momento">

    <!-- ═══════════ Conta nova: cardápio no ar, nenhum pedido ainda ═══════════ -->
    <ng-container *ngSwitchCase="'contaNova'">
      <section class="hc-bloco hc-vitrine" *ngIf="linkCardapio">
        <div class="hc-vitrine__topo">
          <span class="hc-vitrine__logo">
            <img *ngIf="empresa.logo" [src]="'/images/empresa/' + empresa.logo" alt="">
            <span *ngIf="!empresa.logo">{{(empresa.nome || 'L').charAt(0)}}</span>
          </span>
          <div>
            <h2>Sua loja está no ar</h2>
            <button type="button" class="hc-link" (click)="abraLoja()"><i class="fe-link" aria-hidden="true"></i>{{linkCurto}}</button>
          </div>
        </div>
        <div class="hc-vitrine__acoes">
          <button type="button" class="hc-btn hc-btn--zap" (click)="compartilhe()"><i class="fe-send" aria-hidden="true"></i>Mandar para os clientes</button>
          <button type="button" class="hc-btn hc-btn--sec hc-btn--quadrado" (click)="copieLink()" aria-label="Copiar link"><i class="fe-copy" aria-hidden="true"></i></button>
          <button type="button" class="hc-btn hc-btn--sec hc-btn--quadrado" (click)="folha = 'qr'" aria-label="Ver QR Code"><i class="fas fa-qrcode" aria-hidden="true"></i></button>
        </div>
      </section>

      <div class="hc-secao"><h2>Para o primeiro pedido chegar</h2></div>
      <section class="hc-bloco">
        <button type="button" class="hc-linha" (click)="abraLoja()">
          <span class="hc-pastel hc-p-azul"><i class="fe-shopping-cart" aria-hidden="true"></i></span>
          <span class="hc-linha__txt"><b>Faça um pedido de teste</b><span>Veja como ele chega e o celular toca.</span></span>
          <i class="fe-chevron-right hc-seta" aria-hidden="true"></i>
        </button>
        <button type="button" class="hc-linha" (click)="compartilhe()">
          <span class="hc-pastel hc-p-verde"><i class="fe-send" aria-hidden="true"></i></span>
          <span class="hc-linha__txt"><b>Mande o link no WhatsApp</b><span>Para seus contatos e no status de hoje.</span></span>
          <i class="fe-chevron-right hc-seta" aria-hidden="true"></i>
        </button>
        <button type="button" class="hc-linha" (click)="copieLink('Link copiado. Cole na bio do Instagram.')">
          <span class="hc-pastel hc-p-rosa"><i class="fe-instagram" aria-hidden="true"></i></span>
          <span class="hc-linha__txt"><b>Ponha o link na bio do Instagram</b><span>Quem vê o perfil pede sem precisar chamar.</span></span>
          <i class="fe-chevron-right hc-seta" aria-hidden="true"></i>
        </button>
        <button type="button" class="hc-linha" (click)="folha = 'qr'">
          <span class="hc-pastel hc-p-ambar"><i class="fas fa-qrcode" aria-hidden="true"></i></span>
          <span class="hc-linha__txt"><b>Imprima o QR Code</b><span>No balcão, nas mesas e na sacola de entrega.</span></span>
          <i class="fe-chevron-right hc-seta" aria-hidden="true"></i>
        </button>
      </section>

      <ng-container *ngIf="portasDeVenda.length">
        <div class="hc-secao"><h2>Vendeu fora do cardápio?</h2></div>
        <ng-container *ngTemplateOutlet="tplVender"></ng-container>
      </ng-container>
    </ng-container>

    <!-- ═══════════ Antes de abrir ═══════════ -->
    <ng-container *ngSwitchCase="'antes'">
      <section class="hc-bloco hc-relogio">
        <svg class="hc-anel" viewBox="0 0 54 54" aria-hidden="true">
          <circle cx="27" cy="27" r="23" fill="none" class="hc-anel__fundo" stroke-width="6"/>
          <circle cx="27" cy="27" r="23" fill="none" class="hc-anel__frente" stroke-width="6" stroke-linecap="round"
                  stroke-dasharray="144.5" [attr.stroke-dashoffset]="144.5 * (1 - progressoAbertura)" transform="rotate(-90 27 27)"/>
        </svg>
        <div>
          <div class="hc-relogio__h">Abre às {{proximaAbertura}}</div>
          <div class="hc-relogio__s">{{faltaParaAbrir}}. A loja abre sozinha no horário.</div>
        </div>
      </section>
      <ng-container *ngTemplateOutlet="tplLink"></ng-container>

      <ng-container *ngIf="exibirCaixa && !caixa.aberto">
        <div class="hc-secao"><h2>Deixe pronto</h2></div>
        <section class="hc-bloco">
          <button type="button" class="hc-linha" (click)="abraRota('/admin/meupdv')">
            <span class="hc-pastel hc-p-teal"><i class="fe-inbox" aria-hidden="true"></i></span>
            <span class="hc-linha__txt"><b>Abra o caixa</b><span>Informe o troco que está na gaveta.</span></span>
            <i class="fe-chevron-right hc-seta" aria-hidden="true"></i>
          </button>
        </section>
      </ng-container>

      <ng-container *ngTemplateOutlet="tplAgendados"></ng-container>
    </ng-container>

    <!-- ═══════════ Aberta (ou pausada) ═══════════ -->
    <ng-container *ngSwitchCase="'aberta'">
      <!-- O caixa não mexe em pedido: a faixa de urgências é de quem pode agir neles. -->
      <ng-container *ngIf="!visaoCaixa">
        <button type="button" class="hc-faixa" *ngIf="faixaUrgencias as faixa" (click)="vaParaPedidos()">
          <span class="hc-faixa__topo">
            <span class="hc-faixa__ico"><i class="fe-bell" aria-hidden="true"></i></span>
            <b>{{faixa.titulo}}</b>
            <i class="fe-chevron-right hc-seta" aria-hidden="true"></i>
          </span>
          <span class="hc-fichas">
            <span class="hc-ficha" *ngFor="let parte of faixa.partes"><i [ngClass]="'hc-ponto--' + parte.cor" aria-hidden="true"></i><b>{{parte.qtde}}</b>{{parte.texto}}</span>
          </span>
        </button>
      </ng-container>

      <!-- Quem vê vendas: o negócio primeiro, os pedidos encolhidos aos que pedem ação. -->
      <ng-container *ngIf="visaoDono; else tplAbertaOperacao">
        <ng-container *ngTemplateOutlet="tplHoje"></ng-container>
        <ng-container *ngTemplateOutlet="tplLink"></ng-container>
        <ng-container *ngTemplateOutlet="listaCompleta ? tplPedidos : tplPedidosDono"></ng-container>
        <ng-container *ngTemplateOutlet="tplAgoraNaLoja"></ng-container>
        <ng-container *ngTemplateOutlet="tplOrigens"></ng-container>
      </ng-container>

      <ng-template #tplAbertaOperacao>
        <!-- Caixa: a gaveta, a venda no balcão e o que falta receber. -->
        <ng-container *ngIf="visaoCaixa; else tplAbertaAtendimento">
          <div class="hc-secao"><h2>Caixa</h2></div>
          <section class="hc-bloco">
            <button type="button" class="hc-linha" *ngIf="exibirCaixa" (click)="abraRota('/admin/meupdv')">
              <span class="hc-pastel hc-p-teal"><i class="fe-inbox" aria-hidden="true"></i></span>
              <span class="hc-linha__txt">
                <b>{{caixa.aberto ? 'Caixa aberto desde ' + caixa.desde : 'Caixa fechado'}}</b>
                <span>{{caixa.aberto ? (caixa.operador ? 'Aberto por ' + caixa.operador : 'Em operação') : 'Toque para abrir o caixa'}}</span>
              </span>
              <i class="fe-chevron-right hc-seta" aria-hidden="true"></i>
            </button>
            <div class="hc-linha" *ngIf="funcaoBalcao as balcao">
              <button type="button" class="hc-btn hc-btn--pri hc-btn--largo" (click)="execute(balcao)"><i class="fe-shopping-bag" aria-hidden="true"></i>Venda no balcão</button>
            </div>
          </section>

          <ng-container *ngIf="temModuloPedidos">
            <div class="hc-secao" id="hc-pedidos">
              <h2>A receber <small *ngIf="aReceber.length">{{aReceber.length}}</small></h2>
              <button type="button" (click)="abraRota('/admin/pedidos')">Ver lista</button>
            </div>
            <div class="hc-lista" *ngIf="aReceber.length; else tplNadaAReceber">
              <ng-container *ngFor="let comanda of aReceber; trackBy: identifiqueComanda">
                <ng-container *ngTemplateOutlet="tplComanda; context: {$implicit: comanda}"></ng-container>
              </ng-container>
            </div>
            <ng-template #tplNadaAReceber>
              <section class="hc-bloco hc-tudo-certo">
                <span class="hc-pastel hc-p-verde"><i class="fe-check" aria-hidden="true"></i></span>
                <span><b>Nada a receber agora</b><span>Pedido entregue sem pagamento aparece aqui.</span></span>
              </section>
            </ng-template>
          </ng-container>

          <ng-container *ngTemplateOutlet="tplMesas"></ng-container>
          <ng-container *ngTemplateOutlet="tplAgendados"></ng-container>
          <ng-container *ngTemplateOutlet="tplLink"></ng-container>
        </ng-container>

        <!-- Atendimento: a lista com a próxima ação primeiro. -->
        <ng-template #tplAbertaAtendimento>
          <ng-container *ngTemplateOutlet="tplPedidos"></ng-container>
          <ng-container *ngTemplateOutlet="tplMesas"></ng-container>
          <ng-container *ngTemplateOutlet="tplAgendados"></ng-container>
          <ng-container *ngTemplateOutlet="tplAgoraNaLoja"></ng-container>
          <ng-container *ngTemplateOutlet="tplLink"></ng-container>
        </ng-template>
      </ng-template>
    </ng-container>

    <!-- ═══════════ Fechada, sem abertura hoje ═══════════ -->
    <!-- O que ficou aberto vem antes do resultado; o caixa é o último passo do dia. -->
    <ng-container *ngSwitchCase="'fechou'">
      <ng-container *ngIf="pendenciasFechamento">
        <div class="hc-secao"><h2>{{visaoDono ? 'Pendências do fechamento' : 'Antes de ir embora'}}</h2></div>
        <section class="hc-bloco">
          <button type="button" class="hc-linha" *ngIf="temModuloPedidos && pedidosAbertos.length" (click)="abraRota('/admin/pedidos')">
            <span class="hc-pastel hc-p-cinza"><i class="fe-archive" aria-hidden="true"></i></span>
            <span class="hc-linha__txt">
              <b>{{pedidosAbertos.length}} {{pedidosAbertos.length === 1 ? 'pedido sem finalizar' : 'pedidos sem finalizar'}}</b>
              <span>Finalize ou cancele na lista.</span>
            </span>
            <i class="fe-chevron-right hc-seta" aria-hidden="true"></i>
          </button>
          <button type="button" class="hc-linha" *ngIf="exibirMesas && mesas.ocupadas" (click)="abraRota('/admin/pedidos-mesas')">
            <span class="hc-pastel hc-p-roxo"><i class="fe-grid" aria-hidden="true"></i></span>
            <span class="hc-linha__txt">
              <b>{{mesas.ocupadas}} {{mesas.ocupadas === 1 ? 'mesa ainda aberta' : 'mesas ainda abertas'}}</b>
              <span>Feche as comandas antes do caixa.</span>
            </span>
            <i class="fe-chevron-right hc-seta" aria-hidden="true"></i>
          </button>
          <button type="button" class="hc-linha" *ngIf="exibirCaixa && caixa.aberto" (click)="abraRota('/admin/meupdv')">
            <span class="hc-pastel hc-p-ambar"><i class="fe-inbox" aria-hidden="true"></i></span>
            <span class="hc-linha__txt"><b>Confira a gaveta e feche o caixa</b><span>Aberto desde {{caixa.desde}}{{caixa.operador ? ' por ' + caixa.operador : ''}}.</span></span>
            <i class="fe-chevron-right hc-seta" aria-hidden="true"></i>
          </button>
        </section>
      </ng-container>

      <ng-container *ngIf="visaoDono">
        <ng-container *ngTemplateOutlet="tplHoje"></ng-container>
        <ng-container *ngTemplateOutlet="tplLink"></ng-container>
        <ng-container *ngTemplateOutlet="tplOrigens"></ng-container>
      </ng-container>

      <div class="hc-secao"><h2>Próxima abertura</h2></div>
      <section class="hc-bloco">
        <button type="button" class="hc-linha" (click)="podeGerenciarLoja ? abraRota('/admin/loja/tab/horarios') : null">
          <span class="hc-pastel hc-p-cinza"><i class="fe-sun" aria-hidden="true"></i></span>
          <span class="hc-linha__txt"><b>{{textoEstadoLoja}}</b><span *ngIf="podeGerenciarLoja">Ver os horários da semana</span></span>
          <i class="fe-chevron-right hc-seta" aria-hidden="true" *ngIf="podeGerenciarLoja"></i>
        </button>
      </section>

      <ng-container *ngTemplateOutlet="tplAgendados"></ng-container>
      <ng-container *ngIf="!visaoDono"><ng-container *ngTemplateOutlet="tplLink"></ng-container></ng-container>
    </ng-container>
  </ng-container>

  <!-- ═══════════ Comum a todos os momentos ═══════════ -->
  <ng-container *ngIf="atalhos.length">
    <div class="hc-secao"><h2>Seus atalhos</h2></div>
    <section class="hc-bloco hc-atalhos">
      <button type="button" class="hc-atalho" *ngFor="let funcao of atalhos" (click)="execute(funcao)">
        <span class="hc-pastel" [ngClass]="'hc-p-' + corDaFuncao(funcao)"><i [class]="iconeDaFuncao(funcao.icone)" aria-hidden="true"></i></span>
        {{funcao.nome}}
      </button>
    </section>
  </ng-container>

  <!-- ═══════════ Blocos reaproveitados ═══════════ -->

  <ng-template #tplLink>
    <!-- O link do cardápio numa linha: tocar no endereço copia; QR e Enviar ao lado. -->
    <section class="hc-bloco hc-meu-link" *ngIf="linkCardapio">
      <button type="button" class="hc-meu-link__texto" (click)="copieLink()" aria-label="Copiar o link do cardápio">
        <small><i class="fe-link" aria-hidden="true"></i>Seu cardápio</small>
        <span>{{linkCurto}}</span>
      </button>
      <button type="button" class="hc-meu-link__btn" (click)="folha = 'qr'" aria-label="Ver QR Code"><i class="fas fa-qrcode" aria-hidden="true"></i></button>
      <button type="button" class="hc-meu-link__btn hc-meu-link__btn--enviar" (click)="compartilhe()"><i class="fe-send" aria-hidden="true"></i>Enviar</button>
    </section>
  </ng-template>

  <ng-template #tplPedidos>
    <ng-container *ngIf="temModuloPedidos">
      <div class="hc-secao" id="hc-pedidos">
        <h2>Pedidos agora <small *ngIf="comandas.length">{{comandas.length}}</small></h2>
        <button type="button" (click)="abraRota('/admin/pedidos')">Ver lista</button>
      </div>

      <ng-container *ngIf="comandas.length; else tplTudoCerto">
        <div class="hc-abas" *ngIf="abas.length" role="tablist" aria-label="Filtrar pedidos por etapa">
          <button type="button" class="hc-aba" *ngFor="let aba of abas" role="tab" [attr.aria-selected]="abaAtual === aba.id"
                  [class.on]="abaAtual === aba.id" (click)="escolhaAba(aba.id)">
            {{aba.nome}} <b>{{aba.total}}</b>
          </button>
        </div>

        <div class="hc-lista">
          <ng-container *ngFor="let comanda of comandasNaLista; trackBy: identifiqueComanda">
            <ng-container *ngTemplateOutlet="tplComanda; context: {$implicit: comanda}"></ng-container>
          </ng-container>
        </div>
        <button type="button" class="hc-ver-mais" *ngIf="comandasForaDaLista" (click)="vejaMaisComandas()">
          Ver mais {{comandasForaDaLista}} {{comandasForaDaLista === 1 ? 'pedido' : 'pedidos'}}<i class="fe-chevron-down" aria-hidden="true"></i>
        </button>
      </ng-container>

      <ng-container *ngTemplateOutlet="tplAntigos"></ng-container>
    </ng-container>
  </ng-template>

  <ng-template #tplPedidosDono>
    <ng-container *ngIf="temModuloPedidos">
      <div class="hc-secao" id="hc-pedidos">
        <h2>Pedidos agora <small *ngIf="comandas.length">{{comandas.length}}</small></h2>
      </div>

      <ng-container *ngIf="comandas.length; else tplTudoCerto">
        <div class="hc-etapas" *ngIf="etapasResumo.length > 1">
          <span *ngFor="let etapa of etapasResumo"><b>{{etapa.total}}</b>{{etapa.nome}}</span>
        </div>
        <p class="hc-nota" *ngIf="faixaUrgencias as faixa; else tplSemUrgencia">
          <b>{{faixa.total}} {{faixa.total === 1 ? 'precisa' : 'precisam'}} de você</b> · {{destaquesDono.length === 1 ? 'o mais urgente' : 'os mais urgentes'}}
        </p>
        <ng-template #tplSemUrgencia><p class="hc-nota">Nada urgente · os próximos da fila</p></ng-template>

        <div class="hc-lista">
          <ng-container *ngFor="let comanda of destaquesDono; trackBy: identifiqueComanda">
            <ng-container *ngTemplateOutlet="tplComanda; context: {$implicit: comanda}"></ng-container>
          </ng-container>
        </div>
        <button type="button" class="hc-ver-mais" *ngIf="comandas.length > destaquesDono.length" (click)="listaCompleta = true">
          Ver todos os {{comandas.length}}<i class="fe-chevron-down" aria-hidden="true"></i>
        </button>
      </ng-container>

      <ng-container *ngTemplateOutlet="tplAntigos"></ng-container>
    </ng-container>
  </ng-template>

  <ng-template #tplComanda let-comanda>
    <article class="hc-comanda" [ngClass]="'hc-comanda--' + comanda.tom" [class.hc-comanda--ocupada]="estaProcessando(comanda)">
      <button type="button" class="hc-comanda__cima" (click)="abraComanda(comanda)" [attr.aria-label]="'Abrir ' + comanda.titulo + ' ' + comanda.meta">
        <span class="hc-comanda__topo">
          <span class="hc-avatar" [ngClass]="comanda.pedido ? 'hc-p-' + corDoAvatar(comanda) : 'hc-avatar--pendencia'">
            <ng-container *ngIf="comanda.pedido; else tplAvatarPendencia">{{iniciais(comanda.titulo)}}</ng-container>
            <ng-template #tplAvatarPendencia><i class="fe-alert-triangle" aria-hidden="true"></i></ng-template>
          </span>
          <span class="hc-comanda__quem">
            <b>{{comanda.titulo}}</b>
            <span><em>{{comanda.rotulo}}</em>{{comanda.meta ? ' · ' + comanda.meta : ''}}</span>
          </span>
          <span class="hc-comanda__dir">
            <b *ngIf="comanda.valor !== null">{{moeda(comanda.valor)}}</b>
            <span class="hc-comanda__tempo" [class.hc-comanda__tempo--quente]="comanda.quente" *ngIf="comanda.tempo">
              <i class="fe-clock" aria-hidden="true"></i>{{comanda.tempo}}
            </span>
          </span>
        </span>
        <span class="hc-comanda__itens" *ngIf="comanda.itens.length || comanda.nota">
          <span class="hc-comanda__item" *ngFor="let item of comanda.itens">
            <em>{{item.qtde}}×</em><span>{{item.descricao}}<small *ngIf="item.observacao">{{item.observacao}}</small></span>
          </span>
          <span class="hc-comanda__mais" *ngIf="comanda.maisItens">+ {{comanda.maisItens}} {{comanda.maisItens === 1 ? 'item' : 'itens'}}</span>
          <span class="hc-comanda__nota" *ngIf="comanda.nota">{{comanda.nota}}</span>
        </span>
      </button>
      <div class="hc-comanda__acoes">
        <button type="button" class="hc-btn" *ngIf="comanda.passo; else semPasso"
                [ngClass]="comanda.passo.tipo === 'aceitar' || comanda.passo.status === 'Em preparação' ? 'hc-btn--pri' : 'hc-btn--verde'"
                [disabled]="estaProcessando(comanda)" (click)="executePasso(comanda)">
          <i [class]="estaProcessando(comanda) ? 'fe-loader hc-girando' : comanda.passo.icone" aria-hidden="true"></i>{{comanda.passo.texto}}
        </button>
        <ng-template #semPasso>
          <button type="button" class="hc-btn hc-btn--pri" (click)="abraComanda(comanda)">
            {{comanda.pedido ? 'Ver pedido' : 'Resolver'}}<i class="fe-arrow-right" aria-hidden="true"></i>
          </button>
        </ng-template>
        <button type="button" class="hc-btn hc-btn--sec hc-btn--quadrado" *ngIf="comanda.pedido"
                [disabled]="estaProcessando(comanda)" (click)="abraMais(comanda)" aria-label="Mais ações do pedido">
          <i class="fe-more-horizontal" aria-hidden="true"></i>
        </button>
      </div>
    </article>
  </ng-template>

  <ng-template #tplAntigos>
    <section class="hc-bloco hc-antigos" *ngIf="pedidosAntigos.total">
      <button type="button" class="hc-linha" (click)="abraRota('/admin/pedidos')">
        <span class="hc-pastel hc-p-cinza"><i class="fe-archive" aria-hidden="true"></i></span>
        <span class="hc-linha__txt">
          <b>{{pedidosAntigos.total}} {{pedidosAntigos.total === 1 ? 'pedido antigo' : 'pedidos antigos'}} sem finalizar</b>
          <span>O mais antigo está aberto há {{pedidosAntigos.maisAntigo}}. Finalize ou cancele na lista.</span>
        </span>
        <i class="fe-chevron-right hc-seta" aria-hidden="true"></i>
      </button>
    </section>
  </ng-template>

  <ng-template #tplTudoCerto>
    <section class="hc-bloco hc-tudo-certo">
      <span class="hc-pastel hc-p-verde"><i class="fe-check" aria-hidden="true"></i></span>
      <span><b>Nenhum pedido agora</b><span>O próximo pedido toca e aparece aqui.</span></span>
    </section>
  </ng-template>

  <ng-template #tplHoje>
    <!-- Vendas: o card de destaque da tela, escuro e chapado. -->
    <section class="hc-vendas" *ngIf="exibirHoje">
      <div class="hc-vendas__cab">
        <span>{{momento === 'fechou' && periodo === 'hoje' ? 'Seu dia' : 'Vendas'}}</span>
        <button type="button" (click)="abraRelatorioVendas()">Relatório<i class="fe-arrow-up-right" aria-hidden="true"></i></button>
      </div>
      <div class="hc-periodos" role="tablist" aria-label="Período das vendas">
        <button type="button" *ngFor="let item of periodosVendas" role="tab" [class.on]="periodo === item.id"
                [attr.aria-selected]="periodo === item.id" (click)="escolhaPeriodo(item.id)">{{item.nome}}</button>
      </div>

      <ng-container *ngIf="resumoPeriodo; else tplCarregandoVendas">
        <div class="hc-vendas__topo">
          <span class="hc-valor"><small>R$</small>{{valorSemSimbolo(totalPeriodo)}}</span>
          <span class="hc-horas" *ngIf="barrasHoras.length" aria-hidden="true">
            <span class="hc-horas__col"><i *ngFor="let barra of barrasHoras" [class.melhor]="barra.melhor" [style.height.%]="barra.altura"></i></span>
            <span class="hc-horas__rot"><span *ngFor="let rotulo of rotulosHoras">{{rotulo}}</span></span>
          </span>
        </div>
        <span class="hc-comparacao" *ngIf="variacaoPeriodo as variacao">
          <span class="hc-variacao" [class.hc-variacao--desce]="!variacao.sobe">{{variacao.texto}}</span>{{comparacaoPeriodo}}
        </span>
        <div class="hc-metricas">
          <span><b>{{pedidosPeriodo}}</b>pedidos</span>
          <span><b>{{moeda(ticketPeriodo)}}</b>ticket médio</span>
          <span><b>{{moeda(taxasPeriodo)}}</b>taxas de entrega</span>
        </div>
      </ng-container>
      <ng-template #tplCarregandoVendas><p class="hc-carregando">Carregando as vendas…</p></ng-template>
    </section>
  </ng-template>

  <ng-template #tplOrigens>
    <ng-container *ngIf="exibirHoje && origens.length">
      <div class="hc-secao"><h2>De onde veio</h2></div>
      <section class="hc-bloco hc-origens">
        <div class="hc-empilhada" aria-hidden="true">
          <span *ngFor="let origem of origens" [style.flex-grow]="origem.total" [style.background]="origem.cor"></span>
        </div>
        <div class="hc-legenda" *ngFor="let origem of origens">
          <i [style.background]="origem.cor" aria-hidden="true"></i>
          <span>{{origem.nome}}</span>
          <small>{{origem.fatia}}%</small>
          <b>{{moeda(origem.total)}}</b>
        </div>
      </section>
    </ng-container>
  </ng-template>

  <ng-template #tplVender>
    <section class="hc-bloco hc-vender">
      <button type="button" class="hc-porta" *ngFor="let porta of portasDeVenda" (click)="execute(porta.funcao)">
        <span class="hc-pastel" [ngClass]="'hc-p-' + porta.cor"><i [class]="porta.icone" aria-hidden="true"></i></span>
        <b>{{porta.nome}}</b><small>{{porta.detalhe}}</small>
      </button>
    </section>
  </ng-template>

  <ng-template #tplAgoraNaLoja>
    <div class="hc-secao"><h2>Loja e caixa</h2></div>
    <div class="hc-bento">
      <div class="hc-bento__item hc-bento__item--largo">
        <span class="hc-pastel" [ngClass]="estadoLoja === 'pausada' ? 'hc-p-ambar' : 'hc-p-verde'">
          <i class="fe-pause" *ngIf="estadoLoja === 'pausada'; else tplPontoAberta" aria-hidden="true"></i>
          <ng-template #tplPontoAberta><span class="hc-ponto-aberta"></span></ng-template>
        </span>
        <span class="hc-bento__txt">
          <small>Loja</small>
          <b>{{estadoLoja === 'pausada' ? 'Pausada' : (fechamentoDeHoje ? 'Aberta até ' + fechamentoDeHoje : 'Aberta')}}</b>
          <span *ngIf="estadoLoja === 'pausada'">{{textoEstadoLoja}}</span>
        </span>
        <ng-container *ngIf="podeGerenciarLoja">
          <button type="button" class="hc-mini-btn" *ngIf="estadoLoja === 'aberta'" (click)="pausarLoja()">Pausar</button>
          <button type="button" class="hc-mini-btn hc-mini-btn--pri" *ngIf="estadoLoja === 'pausada'" [disabled]="reabrindo" (click)="reabrirLoja()">
            {{reabrindo ? 'Reabrindo…' : 'Reabrir'}}
          </button>
        </ng-container>
      </div>

      <button type="button" class="hc-bento__item" *ngIf="exibirCaixa && caixa.aberto" [class.hc-bento__item--largo]="!bentoDuplo" (click)="abraRota('/admin/meupdv')">
        <span class="hc-pastel hc-p-teal"><i class="fe-inbox" aria-hidden="true"></i></span>
        <span class="hc-bento__txt">
          <small>Caixa</small>
          <b>{{bentoDuplo ? 'Aberto ' + caixa.desde : 'Aberto desde ' + caixa.desde}}</b>
          <span>{{caixa.operador ? 'por ' + caixa.operador : 'em operação'}}</span>
        </span>
        <i class="fe-chevron-right hc-seta" *ngIf="!bentoDuplo" aria-hidden="true"></i>
      </button>

      <button type="button" class="hc-bento__item" *ngIf="exibirMesas && visaoDono" [class.hc-bento__item--largo]="!bentoDuplo" (click)="abraRota('/admin/pedidos-mesas')">
        <span class="hc-ocupacao" aria-hidden="true">
          <svg viewBox="0 0 38 38">
            <circle cx="19" cy="19" r="15" fill="none" stroke="#f0ebfd" stroke-width="5"/>
            <circle cx="19" cy="19" r="15" fill="none" stroke="#6a3fd1" stroke-width="5" stroke-linecap="round"
                    [attr.stroke-dasharray]="ocupacaoMesas.circunferencia" [attr.stroke-dashoffset]="ocupacaoMesas.resto"/>
          </svg>
          <span>{{mesas.ocupadas}}/{{mesas.total}}</span>
        </span>
        <span class="hc-bento__txt">
          <small>Mesas</small>
          <b>{{mesas.ocupadas}} {{mesas.ocupadas === 1 ? 'ocupada' : 'ocupadas'}}</b>
          <span>de {{mesas.total}} no salão</span>
        </span>
        <i class="fe-chevron-right hc-seta" *ngIf="!bentoDuplo" aria-hidden="true"></i>
      </button>
    </div>
  </ng-template>

  <!-- Mesas da operação: as ocupadas em grade, a mais antiga primeiro; o salão inteiro fica na tela de mesas. -->
  <ng-template #tplMesas>
    <ng-container *ngIf="exibirMesas">
      <div class="hc-secao">
        <h2>Mesas <small *ngIf="mesas.ocupadas">{{mesas.ocupadas}}</small></h2>
        <button type="button" (click)="abraRota('/admin/pedidos-mesas')">Ver salão</button>
      </div>
      <div class="hc-mesas" *ngIf="mesas.ocupadas; else tplSemMesa">
        <button type="button" class="hc-mesa" *ngFor="let mesa of mesasNaGrade" (click)="abraRota('/admin/pedidos-mesas')">
          <small>{{mesa.tempo}}</small><b>{{mesa.nome}}</b><span>{{moeda(mesa.valor)}}</span>
        </button>
      </div>
      <button type="button" class="hc-ver-mais" *ngIf="mesas.ocupadas > 6" (click)="abraRota('/admin/pedidos-mesas')">
        Ver as outras {{mesas.ocupadas - 6}} ocupadas<i class="fe-chevron-right" aria-hidden="true"></i>
      </button>
      <ng-template #tplSemMesa>
        <section class="hc-bloco">
          <button type="button" class="hc-linha" (click)="abraRota('/admin/pedidos-mesas')">
            <span class="hc-pastel hc-p-roxo"><i class="fe-grid" aria-hidden="true"></i></span>
            <span class="hc-linha__txt"><b>Nenhuma mesa ocupada</b><span>{{mesas.total}} {{mesas.total === 1 ? 'livre' : 'livres'}} no salão</span></span>
            <i class="fe-chevron-right hc-seta" aria-hidden="true"></i>
          </button>
        </section>
      </ng-template>
    </ng-container>
  </ng-template>

  <ng-template #tplAgendados>
    <ng-container *ngIf="temModuloPedidos && agendados.length">
      <div class="hc-secao"><h2>Marcados para hoje</h2></div>
      <section class="hc-bloco">
        <button type="button" class="hc-linha" *ngFor="let pedido of agendados"
                (click)="abraRota('/admin/pedidos/detalhes/' + pedido.guid + '?t=' + pedido.id)">
          <span class="hc-pastel hc-p-roxo"><i class="fe-calendar" aria-hidden="true"></i></span>
          <span class="hc-linha__txt"><b>{{clienteAgendado(pedido)}}, às {{hora(pedido.horarioEntregaAgendada)}}</b><span>#{{pedido.codigo}}{{pedido.formaDeEntrega ? ', ' + pedido.formaDeEntrega : ''}}</span></span>
          <span class="hc-linha__dir">{{moeda(pedido.total)}}</span>
        </button>
      </section>
    </ng-container>
  </ng-template>

  <!-- ═══════════ Folhas que sobem de baixo ═══════════ -->

  <div class="hc-veu" *ngIf="folha" (click)="fecheFolha()" aria-hidden="true"></div>

  <div class="hc-folha" *ngIf="folha === 'qr'" role="dialog" aria-modal="true" aria-label="QR Code do cardápio">
    <div class="hc-puxador" aria-hidden="true"></div>
    <div class="hc-folha__topo">
      <h3>QR Code do cardápio</h3>
      <button type="button" class="hc-fechar" (click)="fecheFolha()" aria-label="Fechar"><i class="fe-x" aria-hidden="true"></i></button>
    </div>
    <p class="hc-folha__texto">O cliente aponta a câmera e abre o cardápio. Cole no balcão, nas mesas e na sacola.</p>
    <div class="hc-qr">
      <img src="/qrcode/qrcodeloja" alt="QR Code do cardápio" *ngIf="!qrErro" (error)="qrErro = true">
      <i class="fas fa-qrcode" *ngIf="qrErro" aria-hidden="true"></i>
    </div>
    <div class="hc-folha__acoes">
      <a class="hc-btn hc-btn--sec" href="/qrcode/qrcodeloja" download="qrcode-cardapio.png"><i class="fe-download" aria-hidden="true"></i>Salvar</a>
      <button type="button" class="hc-btn hc-btn--pri" (click)="compartilhe()"><i class="fe-share-2" aria-hidden="true"></i>Compartilhar link</button>
    </div>
  </div>

  <div class="hc-folha" *ngIf="folha === 'mais' && pedidoEmAcao" role="dialog" aria-modal="true" aria-label="Mais ações do pedido">
    <div class="hc-puxador" aria-hidden="true"></div>
    <div class="hc-folha__topo">
      <h3>Pedido #{{pedidoEmAcao.codigo}}</h3>
      <button type="button" class="hc-fechar" (click)="fecheFolha()" aria-label="Fechar"><i class="fe-x" aria-hidden="true"></i></button>
    </div>

    <ng-container *ngIf="statusDaFolhaMais.length">
      <p class="hc-folha__texto">Mudar para</p>
      <section class="hc-bloco">
        <button type="button" class="hc-linha" *ngFor="let status of statusDaFolhaMais" (click)="vaParaStatus(pedidoEmAcao, status)">
          <span class="hc-glifo"><i class="fe-arrow-right-circle" aria-hidden="true"></i></span>
          <span class="hc-linha__txt"><b>{{status}}</b></span>
        </button>
      </section>
    </ng-container>

    <section class="hc-bloco">
      <button type="button" class="hc-linha hc-linha--perigo" *ngIf="podeRecusarAqui" (click)="recuse()">
        <span class="hc-glifo"><i class="fe-x-circle" aria-hidden="true"></i></span>
        <span class="hc-linha__txt">
          <b>{{pedidoEmAcao.origemExterna ? 'Recusar no pedido' : (confirmandoRecusa ? 'Toque de novo para recusar' : 'Recusar pedido')}}</b>
          <span *ngIf="pedidoEmAcao.origemExterna">A plataforma pede o motivo; abre o pedido completo.</span>
          <span *ngIf="!pedidoEmAcao.origemExterna && confirmandoRecusa">O cliente é avisado e o pedido sai da fila.</span>
        </span>
      </button>
      <button type="button" class="hc-linha" (click)="abraPedidoEmAcao()">
        <span class="hc-glifo"><i class="fe-file-text" aria-hidden="true"></i></span>
        <span class="hc-linha__txt"><b>Abrir pedido completo</b><span>Editar, cancelar, imprimir de novo</span></span>
        <i class="fe-chevron-right hc-seta" aria-hidden="true"></i>
      </button>
    </section>
  </div>

  <div class="hc-folha" *ngIf="folha === 'entregador' && pedidoEmAcao" role="dialog" aria-modal="true" aria-label="Escolher entregador">
    <div class="hc-puxador" aria-hidden="true"></div>
    <div class="hc-folha__topo">
      <h3>Quem vai levar?</h3>
      <button type="button" class="hc-fechar" (click)="fecheFolha()" aria-label="Fechar"><i class="fe-x" aria-hidden="true"></i></button>
    </div>
    <p class="hc-folha__texto">Pedido #{{pedidoEmAcao.codigo}} sai para entrega.</p>
    <section class="hc-bloco">
      <button type="button" class="hc-linha" *ngFor="let entregador of entregadores" (click)="escolhaEntregador(entregador)">
        <span class="hc-pastel hc-p-ambar"><i class="fe-navigation" aria-hidden="true"></i></span>
        <span class="hc-linha__txt"><b>{{entregador.nome}}</b></span>
      </button>
      <button type="button" class="hc-linha" (click)="escolhaEntregador(null)">
        <span class="hc-pastel hc-p-cinza"><i class="fe-minus" aria-hidden="true"></i></span>
        <span class="hc-linha__txt"><b>Sem entregador</b></span>
      </button>
    </section>
  </div>

  <div class="hc-folha" *ngIf="folha === 'pagamento' && pedidoEmAcao" role="dialog" aria-modal="true" aria-label="Pagamento do pedido">
    <div class="hc-puxador" aria-hidden="true"></div>
    <div class="hc-folha__topo">
      <h3>{{escolhendoFormaDoSaldo ? 'Como recebeu o saldo?' : textoPagamento}}</h3>
      <button type="button" class="hc-fechar" (click)="fecheFolha()" aria-label="Fechar"><i class="fe-x" aria-hidden="true"></i></button>
    </div>
    <p class="hc-folha__texto">Pedido #{{pedidoEmAcao.codigo}}{{statusEmAcao ? ' vai como entregue.' : '.'}}</p>

    <div class="hc-folha__acoes" *ngIf="!escolhendoFormaDoSaldo">
      <button type="button" class="hc-btn hc-btn--sec" (click)="respondaPagamento(false)">{{statusEmAcao ? 'Ainda não' : 'Cancelar'}}</button>
      <button type="button" class="hc-btn hc-btn--verde" (click)="respondaPagamento(true)"><i class="fe-check" aria-hidden="true"></i>Sim, recebi</button>
    </div>

    <section class="hc-bloco" *ngIf="escolhendoFormaDoSaldo">
      <button type="button" class="hc-linha" *ngFor="let forma of formasDoSaldo" (click)="respondaPagamento(true, forma)">
        <span class="hc-pastel hc-p-teal"><i class="fe-dollar-sign" aria-hidden="true"></i></span>
        <span class="hc-linha__txt"><b>{{forma.descricao}}</b></span>
      </button>
    </section>
  </div>

  <div class="hc-aviso" *ngIf="aviso" role="status">{{aviso}}</div>
</div>
